import React from "react";
import CareersList from "./_components/CareersList";
import { CareersStyleWrapper } from "./Careers.css";
import { Helmet } from "react-helmet";
import Img from "../../assets/images/image";
import HeroSection from "../../Components/HeroSection/HeroSection";
import { Container } from "react-bootstrap";
import Svg from "../../assets/Svgs/Svg";
import TwoColumn from "../../Components/TwoColumn";

const Careers = () => {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Careers - Witmates Technologies</title>
            <meta name="description" content="Discover your full potential by joining our dynamic team of professionals. Explore rewarding career opportunities and work with industry leaders." />
            <link rel="canonical" href="https://www.witmates.com/career" />
         </Helmet>
         <CareersStyleWrapper>
            <HeroSection
               image={Img.careersBanner}
               heading={
                  <>
                     <span className="witmates-theme-color">Accelerate</span> Your <br /> Growth <span className="witmates-theme-color">with Us!</span>
                  </>
               }
               description={
                  <>
                     Join our company to become part of a dynamic team that is driving innovation and shaping the future of technology. At Witmates, we value your creativity, collaboration, and
                     excellence. <br /> With a strong emphasis on professional growth, a supportive work environment, and a commitment to work-life balance, we empower our employees to reach their
                     full potential.
                  </>
               }
            />
            <section className="pt100 pb100 mobPt50">
               <TwoColumn
                  image={Img.careersAtWitmatesGrid}
                  heading={
                     <>
                        Careers at <br /> Witmates
                     </>
                  }
                  pageName="CAREERS"
                  buttonName="APPLY NOW"
                  redirection="#apply-now"
                  isZoom={true}
                  description={
                     <>
                        With a focus on innovation and cutting-edge technology, We are constantly searching for talented individuals who can assist us in shaping the future of the digital landscape.
                        Whether you're a seasoned professional or just starting out, we offer a range of opportunities that cater to all levels of experience. As a transformational IT company, we
                        provide our employees with opportunities to work on innovative projects. Join us and be a part of a dynamic team that is dedicated to creating a better future through
                        technology.
                     </>
                  }
               />
            </section>

            <CareersList />
            <Container className="my-5">
               <div style={{ backgroundImage: `url(${Img.careersQuery})`, minHeight: "292px" }} className="background-css row align-items-center justify-content-center px-5 py-3">
                  <div className="col-12 col-md-12 col-lg-8">
                     <span className="d-block text-white font-48 mb-3 font-syne">Any Query</span>
                     <span className="d-block text-white font-28 font-syne">Urjently want to reach us ?</span>
                     <span className="d-block text-white font-22 font-DMSans font-weight-400">We are available, 5 days aweeks.(And I respond within 5 mins!)</span>
                  </div>
                  <div className="col-12 col-md-12 col-lg-4">
                     <div className="d-flex mt-4">
                        <div className="mt-2">{Svg.careerEmail}&nbsp;&nbsp;&nbsp;</div>
                        <div>
                           <span className="d-block text-white font-27 font-DMSans font-weight-800">Send Us an Email</span>
                           <a href="mailto:hr@witmates.com" className="d-block text-white font-20 font-DMSans" target="_blank">
                              hr@witmates.com
                           </a>
                        </div>
                     </div>
                     <div className="d-flex mt-4">
                        <div className="mt-2">{Svg.careerPhone}&nbsp;&nbsp;&nbsp;</div>
                        <div>
                           <span className="d-block text-white font-27 font-DMSans font-weight-800">Call at</span>
                           <span className="d-block font-20">
                              <a href="tel:+91-888-991-1196" className="font-DMSans text-white">
                                 0731-498-9377
                              </a>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </Container>
         </CareersStyleWrapper>
      </div>
   );
};

export default Careers;
